import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';
import { getStorageItem, setStorageItem } from 'CorePackage/MainModule/common/localStore';

import { IPmListFilterState } from '../interfaces/IPmListFilterState';
import { PmListFilterAction } from '../types/PmListFilterAction';
import { PmListFilterActionsEnum } from '../enums/PmListFilterActionsEnum';
import { IPmListFilterWithMeta } from '../interfaces/IPmListFilterWithMeta';

const initialState: IPmListFilterState = {
  current: getStorageItem(StorageNamesEnum.PM_FILTER),
  isFilterOn: !!getStorageItem(StorageNamesEnum.PM_FILTER_ON),
  filters: [],
  currentControlOrganizations: [],
  currentSupervisionTypes: [],
};

export function pmListFilterReducer(state = initialState, action: PmListFilterAction) {
  switch (action.type) {
    case PmListFilterActionsEnum.PM_LIST_FILTER_SET_CURRENT: {
      const { current, currentId } = action.payload;
      const newState: IPmListFilterState = {
        ...state,
        current,
        currentId,
      };

      setStorageItem(StorageNamesEnum.PM_FILTER, current);

      return newState;
    }
    case PmListFilterActionsEnum.PM_LIST_FILTER_SET_SWITCHER: {
      const { value: isFilterOn } = action.payload;
      const newState: IPmListFilterState = {
        ...state,
        isFilterOn,
      };

      setStorageItem(StorageNamesEnum.PM_FILTER_ON, isFilterOn);

      return newState;
    }
    case PmListFilterActionsEnum.PM_LIST_FILTER_SET_META: {
      const filters = action.payload.list.map<IPmListFilterWithMeta>(meta => ({ meta }));
      const newState: IPmListFilterState = {
        ...state,
        filters,
      };

      return newState;
    }
    case PmListFilterActionsEnum.PM_LIST_FILTER_REMOVE: {
      const { id } = action.payload;
      const filters = state.filters.filter(f => f.meta.id !== id);
      const newState: IPmListFilterState = {
        ...state,
        filters,
      };

      return newState;
    }
    case PmListFilterActionsEnum.PM_LIST_FILTER_SET_DATA: {
      const { id, data } = action.payload;
      const filters = state.filters.map<IPmListFilterWithMeta>(filter => {
        if (filter.meta.id === id) {
          return {
            ...filter,
            data,
            meta: {
              ...filter.meta,
              id,
              name: data.name,
            },
          };
        }

        return filter;
      });
      const newState: IPmListFilterState = {
        ...state,
        filters,
      };

      return newState;
    }
    case PmListFilterActionsEnum.PM_LIST_FILTER_SET_CURRENT_CONTROL_ORGANIZATIONS: {
      const { ids } = action.payload;
      const newState: IPmListFilterState = {
        ...state,
        currentControlOrganizations: ids,
      };

      return newState;
    }
    case PmListFilterActionsEnum.PM_LIST_FILTER_SET_CURRENT_SUPERVISION_TYPES: {
      const { ids } = action.payload;
      const newState: IPmListFilterState = {
        ...state,
        currentSupervisionTypes: ids,
      };

      return newState;
    }
    default:
      return state;
  }
}
